import React, { useState, useEffect } from 'react';
import { Heart, ThumbsUp, Flame } from 'lucide-react';

const cheerIcons = [
    { Icon: Heart, color: "text-red-500" },
    { Icon: ThumbsUp, color: "text-blue-500" },
    { Icon: Flame, color: "text-orange-500" },
];

const CheerAnimation = ({ cheers }) => {
    const [animations, setAnimations] = useState([]);

    useEffect(() => {
        if (cheers.length > 0) {
            const newCheer = cheers[cheers.length - 1];
            const { Icon, color } = cheerIcons[Math.floor(Math.random() * cheerIcons.length)];
            const newAnimation = {
                id: newCheer.id,
                Icon: Icon,
                color: color,
                style: {
                    left: `${Math.random() * 80 + 10}%`,
                    animationDuration: `${Math.random() * 2 + 3}s`,
                    transform: `scale(${Math.random() * 0.5 + 0.8}) rotate(${Math.random() * 40 - 20}deg)`,
                },
            };
            setAnimations(prev => [...prev, newAnimation]);

            setTimeout(() => {
                setAnimations(prev => prev.filter(a => a.id !== newAnimation.id));
            }, 5000);
        }
    }, [cheers]);

    return (
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
            {animations.map(anim => (
                <div key={anim.id} style={anim.style} className="absolute bottom-0 animate-floatUp">
                    <anim.Icon className={anim.color} size={32} fill="currentColor" />
                </div>
            ))}
        </div>
    );
};

export default CheerAnimation;
